import { getTopSearchesIdFromUrl, makeTopSearchesUrl } from 'Helpers/topSearches';

export const initialState = {
    list: {},
    fetching: {}
};

export const urls = {
    getTopSearches: makeTopSearchesUrl
};

const setTopSearches = (state, {
    url,
    data: {
        data: {
            searches
        }
    }
}) => {
    const id = getTopSearchesIdFromUrl(url);

    return {
        ...state,
        list: {
            ...state.list,
            [id]: searches
        },
        fetching: {
            ...state.fetching,
            [id]: false
        }
    };
};

const toggleFetching = toggle => (state, { url }) => ({
    ...state,
    fetching: {
        ...state.fetchingTopSearches,
        [getTopSearchesIdFromUrl(url)]: toggle
    }
});

const fetchTopSearches = toggleFetching(true);
const errorTopSearches = toggleFetching(false);

export default (state = initialState, action) => {
    switch (action.type) {
        case 'RECEIVE_TOP_SEARCHES':
            return setTopSearches(state, action);
        case 'ERROR_TOP_SEARCHES':
            return errorTopSearches(state, action);
        case 'REQUEST_TOP_SEARCHES':
            return fetchTopSearches(state, action);
        default:
            return state;
    }
};
